/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14.9958 1C14.9958 1.41044 15.123 2.52983 13.9783 3.72384C13.1304 4.58204 12.113 5.06711 11.0107 4.99248C10.9259 3.98503 11.3499 3.05221 12.113 2.30595C12.7913 1.63432 13.9783 1.07463 14.9958 1Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.3617 12.3181C16.3617 10.796 17.0851 9.68519 18.4894 8.82126C17.6809 7.71048 16.4894 7.13452 14.9149 7.0111C13.383 6.88768 11.7234 7.8339 11.1277 7.8339C10.4894 7.8339 9.04255 7.05224 7.89362 7.05224C5.51064 7.09338 3 8.8624 3 12.5238C3 13.5935 3.17021 14.7043 3.59574 15.8562C4.14894 17.3783 6.10638 21.0809 8.14894 20.9986C9.21277 20.9986 9.97872 20.2581 11.383 20.2581C12.7447 20.2581 13.4255 20.9986 14.617 20.9986C16.7021 20.9986 18.4894 17.6252 19 16.103C16.234 14.8277 16.3617 12.4004 16.3617 12.3181Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M16.3617 12.3181C16.3617 10.796 17.0851 9.68519 18.4894 8.82126C17.6809 7.71048 16.4894 7.13452 14.9149 7.0111C13.383 6.88768 11.7234 7.8339 11.1277 7.8339C10.4894 7.8339 9.04255 7.05224 7.89362 7.05224C5.51064 7.09338 3 8.8624 3 12.5238C3 13.5935 3.17021 14.7043 3.59574 15.8562C4.14894 17.3783 6.10638 21.0809 8.14894 20.9986C9.21277 20.9986 9.97872 20.2581 11.383 20.2581C12.7447 20.2581 13.4255 20.9986 14.617 20.9986C16.7021 20.9986 18.4894 17.6252 19 16.103C16.234 14.8277 16.3617 12.4004 16.3617 12.3181Z"
					fill="currentColor"
				/>
				<path
					d="M14.9958 1C14.9958 1.41044 15.123 2.52983 13.9783 3.72384C13.1304 4.58204 12.113 5.06711 11.0107 4.99248C10.9259 3.98503 11.3499 3.05221 12.113 2.30595C12.7913 1.63432 13.9783 1.07463 14.9958 1Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M16.3617 12.3181C16.3617 10.796 17.0851 9.68519 18.4894 8.82126C17.6809 7.71048 16.4894 7.13452 14.9149 7.0111C13.383 6.88768 11.7234 7.8339 11.1277 7.8339C10.4894 7.8339 9.04255 7.05224 7.89362 7.05224C5.51064 7.09338 3 8.8624 3 12.5238C3 13.5935 3.17021 14.7043 3.59574 15.8562C4.14894 17.3783 6.10638 21.0809 8.14894 20.9986C9.21277 20.9986 9.97872 20.2581 11.383 20.2581C12.7447 20.2581 13.4255 20.9986 14.617 20.9986C16.7021 20.9986 18.4894 17.6252 19 16.103C16.234 14.8277 16.3617 12.4004 16.3617 12.3181Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9958 1C14.9958 1.41044 15.123 2.52983 13.9783 3.72384C13.1304 4.58204 12.113 5.06711 11.0107 4.99248C10.9259 3.98503 11.3499 3.05221 12.113 2.30595C12.7913 1.63432 13.9783 1.07463 14.9958 1Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M15.7458 1C15.7458 0.791558 15.659 0.592517 15.5064 0.450618C15.3537 0.308719 15.1488 0.236764 14.9409 0.252011C13.743 0.339876 12.3902 0.977003 11.587 1.77131C10.7002 2.63928 10.1561 3.78079 10.2633 5.05538C10.2944 5.42456 10.5904 5.71574 10.96 5.74077C12.3343 5.83381 13.5537 5.22079 14.5118 4.25096L14.5197 4.24287C15.1895 3.54419 15.5066 2.8434 15.647 2.23734C15.7641 1.73164 15.7528 1.29185 15.7474 1.0825C15.7465 1.04882 15.7458 1.02106 15.7458 1Z"
				fill="currentColor"
			/>
			<path
				d="M14.9742 6.26346C14.0522 6.18938 13.1353 6.4366 12.4385 6.6629C12.2605 6.72073 12.0914 6.77915 11.9376 6.8326L11.8816 6.85206C11.7483 6.89845 11.6298 6.93966 11.5206 6.97567C11.3957 7.01681 11.298 7.04609 11.2214 7.06473C11.1628 7.07898 11.1336 7.08266 11.1262 7.0836C11.1251 7.08374 11.1245 7.08382 11.1243 7.08386C11.0823 7.0829 10.9654 7.06425 10.7309 6.99362C10.5716 6.94566 10.4018 6.88804 10.2087 6.82249C10.1239 6.79371 10.0346 6.76339 9.93971 6.7317C9.36386 6.53937 8.60615 6.30224 7.89362 6.30224L7.88067 6.30236C6.51329 6.32596 5.10206 6.84468 4.02882 7.89421C2.94555 8.95354 2.25 10.5109 2.25 12.5238C2.25 13.6752 2.43361 14.8739 2.89153 16.1142C3.18966 16.9339 3.8489 18.3041 4.70982 19.4737C5.14106 20.0595 5.64441 20.6248 6.20376 21.044C6.75595 21.4579 7.42317 21.7738 8.16373 21.7486C8.79447 21.7454 9.34264 21.54 9.78208 21.3753C9.82185 21.3604 9.86075 21.3458 9.89871 21.3317C10.3832 21.1523 10.8211 21.0081 11.383 21.0081C11.9173 21.0081 12.3181 21.1481 12.7985 21.3299L12.8698 21.3569C13.3294 21.5316 13.9007 21.7487 14.617 21.7487C15.3458 21.7487 16 21.4539 16.5501 21.0548C17.1002 20.6558 17.5869 20.1238 18 19.5702C18.8239 18.4661 19.4333 17.1696 19.7111 16.3415C19.8328 15.9786 19.6617 15.5822 19.314 15.4219C17.0393 14.3731 17.107 12.4527 17.1115 12.3243L17.1117 12.3181C17.1117 11.6829 17.2605 11.1639 17.5367 10.7175C17.8166 10.2651 18.2522 9.84772 18.8824 9.46005C19.0604 9.35052 19.1846 9.17167 19.2251 8.96661C19.2656 8.76155 19.2187 8.54888 19.0957 8.37989C18.1302 7.05334 16.7143 6.4 14.9742 6.26346Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 12.5238C3 13.5935 3.17021 14.7043 3.59574 15.8562C4.14894 17.3783 6.10638 21.0809 8.14894 20.9986C9.21277 20.9986 9.97872 20.2581 11.383 20.2581C12.7447 20.2581 13.4255 20.9986 14.617 20.9986C16.7021 20.9986 18.4894 17.6252 19 16.103C16.234 14.8277 16.3617 12.4004 16.3617 12.3181C16.3617 10.796 17.0851 9.68519 18.4894 8.82126C17.6809 7.71048 16.4894 7.13452 14.9149 7.0111C13.383 6.88768 11.7234 7.8339 11.1277 7.8339C10.4894 7.8339 9.04255 7.05224 7.89362 7.05224C6.44555 7.07724 4.95034 7.74029 4 9.0783M13.9783 3.72384C15.123 2.52983 14.9958 1.41044 14.9958 1C13.9783 1.07463 12.7913 1.63432 12.113 2.30595C11.3499 3.05221 10.9259 3.98503 11.0107 4.99248"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16.3617 12.3181C16.3617 10.796 17.0851 9.68519 18.4894 8.82126C17.6809 7.71048 16.4894 7.13452 14.9149 7.0111C13.383 6.88768 11.7234 7.8339 11.1277 7.8339C10.4894 7.8339 9.04255 7.05224 7.89362 7.05224C5.51064 7.09338 3 8.8624 3 12.5238C3 13.5935 3.17021 14.7043 3.59574 15.8562C4.14894 17.3783 6.10638 21.0809 8.14894 20.9986C9.21277 20.9986 9.97872 20.2581 11.383 20.2581C12.7447 20.2581 13.4255 20.9986 14.617 20.9986C16.7021 20.9986 18.4894 17.6252 19 16.103C16.234 14.8277 16.3617 12.4004 16.3617 12.3181Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.9958 1C14.9958 1.41044 15.123 2.52983 13.9783 3.72384C13.1304 4.58204 12.113 5.06711 11.0107 4.99248C10.9259 3.98503 11.3499 3.05221 12.113 2.30595C12.7913 1.63432 13.9783 1.07463 14.9958 1Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M14.9742 6.26339C14.0522 6.18931 13.1353 6.43653 12.4385 6.66283C12.2605 6.72066 12.0914 6.77908 11.9376 6.83253L11.8816 6.852C11.7483 6.89838 11.6298 6.93959 11.5206 6.97561C11.3957 7.01674 11.298 7.04602 11.2214 7.06466C11.1628 7.07891 11.1336 7.08259 11.1262 7.08353L11.1243 7.08379C11.0823 7.08283 10.9654 7.06419 10.7309 6.99355C10.5716 6.94559 10.4018 6.88797 10.2087 6.82242C10.1239 6.79364 10.0346 6.76332 9.93971 6.73163C9.36386 6.53931 8.60615 6.30218 7.89362 6.30218L7.88067 6.30229C6.51329 6.32589 5.10206 6.84462 4.02882 7.89414C2.94555 8.95347 2.25 10.5109 2.25 12.5238C2.25 13.6751 2.43361 14.8739 2.89153 16.1141C3.18966 16.9338 3.8489 18.304 4.70982 19.4736C5.14106 20.0595 5.64441 20.6247 6.20376 21.044C6.75595 21.4579 7.42317 21.7737 8.16373 21.7485C8.79447 21.7454 9.34264 21.5399 9.78208 21.3752C9.82185 21.3603 9.86075 21.3457 9.89871 21.3317C10.3832 21.1523 10.8211 21.0081 11.383 21.0081C11.9173 21.0081 12.3181 21.1481 12.7985 21.3298L12.8698 21.3569C13.3294 21.5315 13.9007 21.7486 14.617 21.7486C15.3458 21.7486 16 21.4539 16.5501 21.0548C17.1002 20.6557 17.5869 20.1238 18 19.5701C18.8239 18.466 19.4333 17.1695 19.7111 16.3415C19.8328 15.9785 19.6617 15.5821 19.314 15.4219C17.0393 14.373 17.107 12.4527 17.1115 12.3242L17.1117 12.3181C17.1117 11.6828 17.2605 11.1638 17.5367 10.7174C17.8166 10.265 18.2522 9.84765 18.8824 9.45998C19.0604 9.35045 19.1846 9.1716 19.2251 8.96654C19.2656 8.76148 19.2187 8.54882 19.0957 8.37982C18.1302 7.05327 16.7143 6.39994 14.9742 6.26339Z"
				fill="currentColor"
			/>
			<path
				d="M15.7458 1C15.7458 0.791558 15.659 0.592517 15.5063 0.450618C15.3536 0.308719 15.1488 0.236764 14.9409 0.252011C13.7429 0.339876 12.3902 0.977003 11.5869 1.77131C10.7001 2.63928 10.156 3.78079 10.2633 5.05538C10.2944 5.42456 10.5904 5.71574 10.96 5.74077C12.3343 5.83381 13.5536 5.22079 14.5118 4.25096L14.5197 4.24287C15.1895 3.54419 15.5065 2.8434 15.6469 2.23734C15.7641 1.73164 15.7527 1.29185 15.7473 1.0825C15.7465 1.04882 15.7458 1.02106 15.7458 1Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
